import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { DataObject } from '@shared/models/data-object.model';
import { EntityType } from '@shared/models/entity-enum';

const ENTITY_PLURAL = {
  lease: 'Lease Comps',
  sale: 'Sale Comps',
  availability: 'Availabilities',
  property: 'Properties',
  company: 'Companies',
  contact: 'Contacts',
  tim: 'TIMs',
  tenancy: 'Tenancies',
  portfoliosale: 'Portfolio Sales',
  default: 'Records',
};

@Component({
  selector: 'miq-exportlimit-alert',
  templateUrl: './exportlimit-alert.component.html',
  styleUrls: ['./exportlimit-alert.component.scss'],
  standalone: false,
})
export class ExportlimitAlertComponent implements OnInit, OnDestroy {
  isExceedLimit: boolean;
  messageArgs: DataObject;
  public entityType = EntityType;
  exportOptions: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<ExportlimitAlertComponent>,
    formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public injectedData
  ) {
    const savedOptions = JSON.parse(localStorage.getItem('exportOptions')) || {};
    const { column = 'selected', allowDuplicates = false, downloadView = 'table' } = savedOptions;

    this.exportOptions = formBuilder.group({
      column: [column],
      allowDuplicates: [allowDuplicates],
      downloadView: [downloadView],
    });
    const entity = ENTITY_PLURAL[this.injectedData.entity?.toLowerCase()] ?? ENTITY_PLURAL.default;
    if (entity === ENTITY_PLURAL.lease) {
      /**
       *since options need to be saved for clipboard and search page, for search page exportOptions has 4 options and clipboard has 3 options.
       * Inorder to retain those values based on clipboard and search page we first fetch from local storage and add new options based on clipboard or search page
       * In clipboard only lease has 4 options with  export in order to align the changes with search page !! is added which return true or false.
       */
      this.exportOptions.addControl('property', new FormControl(!!savedOptions?.property));
      this.splitRecordsChange({ value: !!savedOptions?.property } as MatRadioChange);
    }
    this.exportOptions.valueChanges.subscribe(this._saveExportOptions);
  }

  ngOnInit() {
    const exportedRecords = this.injectedData.recordsCount;
    const exportLimit = this.injectedData.limit;
    const entity = ENTITY_PLURAL[this.injectedData.entity?.toLowerCase()] ?? ENTITY_PLURAL.default;
    this.isExceedLimit = exportLimit - exportedRecords < 0;
    const isSpacesViewActive = this.injectedData.isSpacesViewActive || false;
    if (isSpacesViewActive) {
      this.exportOptions.patchValue({ property: true });
    }

    const toBeRemoved = exportedRecords - exportLimit;
    this.messageArgs = { exportLimit, entity, toBeRemoved };
  }

  private _saveExportOptions = () => {
    /**
     *since options need to be saved for clipboard and search page, for search page exportOptions has 4 options and clipboard has 3 options.
     * Inorder to retain those values based on clipboard and search page we first fetch from local storage and add new options based on clipboard or search page
     */
    const savedData = JSON.parse(localStorage.getItem('exportOptions')) || {};
    localStorage.setItem('exportOptions', JSON.stringify({ ...savedData, ...this.exportOptions.value }));
  };

  public splitRecordsChange(event: MatRadioChange) {
    if (event.value) {
      this.exportOptions.controls.downloadView.setValue('table');
      this.exportOptions.controls.downloadView.disable();
      return;
    }
    this.exportOptions.controls.downloadView.enable();
  }

  public continueExport(format: 'csv' | 'xlsx' = 'csv') {
    this.dialogRef.close({ ...this.exportOptions.getRawValue(), format });
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
